import { ReactNode } from 'react';
import { ControllerFieldState } from 'react-hook-form';
import s from './InputError.module.scss';
import clsx from 'clsx';

export interface InputErrorProps {
    fieldState?: ControllerFieldState;
    className?: string;
    errorMessage?: string;
}

export function InputError({
    fieldState,
    errorMessage,
    className: classNameProps,
}: InputErrorProps): ReactNode {
    const resolvedErrorMessage =
        errorMessage ||
        fieldState?.error?.message ||
        (fieldState?.error?.type === 'required'
            ? 'This field is required'
            : undefined);

    if (!resolvedErrorMessage) {
        return null;
    }

    const className = clsx(s.errorMessage, classNameProps);
    return <small className={className}>{resolvedErrorMessage}</small>;
}
